import React, { Component } from 'react'
import Recaptcha from 'react-recaptcha'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CommonFetch from '../../../requests/commonFetch'
import Notification from '../../Settings/Notification/index.jsx'
import uuidv3 from 'uuid/v3'

export default class Payment extends Component {
    constructor(props) {
        super(props)

        this.state = {
            login_data: {
                email: '',
                password: '',
                recaptcha: '',
            },
            loading: false,
            notification: {},
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    sendAuthorizationForm = () => {
        let { switchSignIn, getPaymentInfo } = this.props
        let { login_data } = this.state
        let login_data_array = Object.keys(login_data)

        let form = new FormData()
        login_data_array.forEach(item => {
            if (item === 'recaptcha') {
                form.append('g-recaptcha-response', login_data[item])
            } else {
                form.append(item, login_data[item])
            }
        })

        this.changeLoadingStatus()

        CommonFetch({
            path: 'ui/auth/post_login',
            method: 'POST',
            data: form,
        }).then(data => {
            console.log(data)
            this.changeLoadingStatus()
            if (data.success || data.error === 'already_logged_in') {
                switchSignIn()
                getPaymentInfo()
            } else {
                this.recaptcha.reset()
                this.handleLoginChange('recaptcha', '')
                this.changeNotificationStatus({
                    type: 'error',
                    description:
                        data.error.replace(/[^a-z]/gi, ' ')[0].toUpperCase() +
                        data.error.replace(/[^a-z]/gi, ' ').slice(1),
                })
            }
        })
    }

    handleLoginChange = (type, event) => {
        let login_data = Object.assign({}, this.state.login_data)
        login_data[type] = type === 'recaptcha' ? event : event.target.value
        this.setState({
            login_data,
        })
    }

    loginDataValidation = event => {
        event.preventDefault()
        if (this.state.loading) return null
        let { login_data } = this.state
        let login_data_array = Object.keys(login_data)
        let validation_result = login_data_array.filter(item => {
            return !login_data[item]
        })
        !validation_result.length ? this.sendAuthorizationForm() : null
    }

    render() {
        let { login_data, notification, loading } = this.state
        let { email, password } = login_data
        return (
            <div className="payment__box payment__box_right">
                <p className="payment__text-size_m payment__margin-bottom_s">
                    {this.translation['Your depository']}
                </p>
                <p className="payment__desc payment__margin-bottom_s">
                    {this.translation['Please login before continue']}
                </p>
                <form
                    className="payment-form"
                    onSubmit={this.loginDataValidation}
                    autoComplete="off"
                >
                    <div className="payment-form__group">
                        <input
                            type="email"
                            value={email}
                            onChange={event =>
                                this.handleLoginChange('email', event)
                            }
                            className="payment-form__input"
                            placeholder="Email"
                            autoComplete="off"
                            required
                        />
                        <label htmlFor="email" className="payment-form__label">
                            Email
                        </label>
                    </div>
                    <div className="payment-form__group">
                        <input
                            type="password"
                            value={password}
                            onChange={event =>
                                this.handleLoginChange('password', event)
                            }
                            className="payment-form__input"
                            placeholder={this.translation['Password']}
                            autoComplete="new-password"
                            required
                        />
                        <label
                            htmlFor="password"
                            className="payment-form__label"
                        >
                            {this.translation['Password']}
                        </label>
                    </div>
                    <Link to="/recover">
                        <p className="payment__link payment__link_left">
                            {this.translation['Forgot your password?']}
                        </p>
                    </Link>
                    {this.recaptchaWrap()}
                    {!loading ? (
                        <input
                            className="payment__button"
                            type="submit"
                            value={this.translation['Login']}
                        />
                    ) : (
                        <div className="payment__spinner">
                            <FontAwesomeIcon icon={'spinner'} />
                        </div>
                    )}
                </form>
                <Link to="/registration">
                    <p className="payment__link">
                        {this.translation['Haven’t registered yet?']}
                    </p>
                </Link>
                <Notification
                    notification={notification}
                    changeNotificationStatus={this.changeNotificationStatus}
                />
            </div>
        )
    }

    recaptchaWrap = () => {
        let { captchaKey } = this.props

        if (!captchaKey) return null
        return (
            <Recaptcha
                sitekey={captchaKey}
                ref={e => (this.recaptcha = e)}
                render="explicit"
                theme="dark"
                size="normal"
                badge="inline"
                verifyCallback={event =>
                    this.handleLoginChange('recaptcha', event)
                }
                hl={localStorage.language}
            />
        )
    }

    changeLoadingStatus = () => {
        this.setState({
            loading: !this.state.loading,
        })
    }

    changeNotificationStatus = options => {
        let notification = {}

        if (Object.keys(options).length) {
            Object.keys(options).forEach(item => {
                notification[item] = options[item]
            })
            notification['uuid'] = uuidv3(
                Object.values(notification).join(''),
                uuidv3.URL
            )
        }

        this.setState({
            notification,
        })
    }
}
